import ContainerLayout from "./containerlayout"
import Apply from "./howToApply/apply"
import Malaysian from "./howToApply/malaysian"
import International from "./howToApply/international"
import { PropTypes } from 'prop-types';
import ModelView from "./howToApply/modelView";

const ApplySection = ({ admission }) => {

    const header1 = admission?.header1
    const description1 = admission?.description1
    const applyButton1 = admission?.applyButton1?.items?.map(item => {
        item = item?.content?.properties

        return {
            label: item?.label,
            url: item?.pagePath?.route?.path
        }
    })
    const applyButton2 = admission?.applyButton2?.items?.map(item => {
        item = item?.content?.properties

        return {
            label: item?.label,
            url: item?.pagePath?.route?.path
        }
    })

    return (
        <ContainerLayout color="bg-[#161624] text-white">

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 place-items-center w-full ">
                <div className="grid gap-5">
                    <h1 className="w-auto   text-white text-4xl font-bold ">{header1}</h1>
                    <p className="text-justify text-slate-300">{description1}</p>
                </div>
                <div className="max-w-[27rem] w-full  bg-white shadow-lg rounded-xl p-5 flex flex-col gap-8 py-8">
                    <h2 className="text-red-600 uppercase font-bold text-sm">APPLY UNITEN</h2>
                    <h1 className="text-3xl font-bold max-w-[8ch] text-[#040430]">
                        Empowering Futures.
                    </h1>
                    <div className="grid gap-3">
                        {
                            applyButton1?.map((button, index) => {
                                return (
                                    <Apply key={index} text={button?.label} >
                                        <ModelView url={button?.url} />
                                    </Apply>
                                )
                            })

                        }
                        {
                            applyButton2?.map((button, index) => {
                                return (
                                    <Apply key={index} text={button?.label} >
                                        <ModelView url={button?.url} />
                                    </Apply>
                                )
                            })

                        }
                        {/* <Apply text="How to Apply - Malaysian" >
                            <Malaysian />
                        </Apply>
                        <Apply text="How To Apply - International" >
                            <International />
                        </Apply> */}
                    </div>

                </div>
            </div>
        </ContainerLayout>

    )
}
ApplySection.propTypes = {
    admission: PropTypes.any
}
export default ApplySection